export interface ITypeGuard {
  string: (v: unknown) => v is string;
  number: (v: unknown) => v is number;
  undefined: (v: unknown) => v is undefined;
  record: (v: unknown) => v is Record<string, unknown>;
  boolean: (v: unknown) => v is boolean;
  readonlyArray: <Value>(v: unknown) => v is readonly Value[];
  isPromise: <Value>(v: unknown) => v is Promise<Value>;
}

export const is: ITypeGuard = {
  string: (v: unknown): v is string => typeof v === 'string',
  number: (v: unknown): v is number => typeof v === 'number',
  undefined: (v: unknown): v is undefined => typeof v === 'undefined',
  record: (v: unknown): v is Record<string, unknown> => v !== null && typeof v === 'object',
  boolean: (v: unknown): v is boolean => typeof v === 'boolean',
  readonlyArray: <Value>(v: unknown): v is readonly Value[] => Array.isArray(v),
  isPromise: <Value>(v: unknown): v is Promise<Value> => v instanceof Promise,
};
